module.exports = __webpack_public_path__ + "img/Logo-edese-hd.bc879620.png";